import React from 'react';
import { Container } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DataReactTable from './components/DataReactTable';


const PendingTable = () => (
  <div>
    
    <Container>
      <Breadcrumbs 
        aria-label="breadcrumb"
        style={{
          marginLeft: '12px',
          marginBottom: '5px',
        }}
      >
      
        <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
        <Typography sx={{ color: 'text.primary' }}>Payment</Typography>
        <Typography sx={{ color: 'text.primary' }}>Pending</Typography>
    
      </Breadcrumbs>
      <DataReactTable />
    </Container>
  </div>
  
  );

export default PendingTable;

